import client from "./client";

export const myFeatureRequests = async () => (await client.get("/features/requests")).data;
export const requestFeature = async (feature) => (await client.post("/features/requests", { feature })).data;
